import { httpCreate } from './http';

const http = httpCreate('/shop/api/resell-detail');

export const resellDetail = {
	//后台-推广业绩
	getResellDetail(pageSize, pageNum, params) {
		return http.post(`/list?pageSize=${pageSize}&pageNum=${pageNum}`, params);
	},
};
